import { render } from "./NavigationDrawer.vue?vue&type=template&id=27b4b1a5&scoped=true"
import script from "./NavigationDrawer.vue?vue&type=script&lang=js"
export * from "./NavigationDrawer.vue?vue&type=script&lang=js"

import "./NavigationDrawer.styles.css?vue&type=style&index=0&id=27b4b1a5&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27b4b1a5"]])

export default __exports__